import {OptionGroup, PrepOption} from "../PrepMenuOptions";
import {Typography} from "@mui/material";
import {PrepMenu} from "./PrepMenu";
import React from "react";

export function AllProps(props: {
    value: PrepOption;
    onChange(value: Partial<PrepOption>): void;
    group: OptionGroup;
}) {

    const group = props.group;

    return (
        <>
            <Typography variant="body2">HW Preps (Single)</Typography>
            <div style={{height: 8}}/>
            <PrepMenu id="single-frame" name="Frame"
                      value={props.value}
                      editKey="singleFramePrep" editKeyCustom="singleFramePrepCustomTemplate"
                      editKeyCustomName="singleFramePrepCustomTemplateName"
                      groupKey="singleFramePreps" groupCustomKey="singleFramePrepsCustom"
                      group={group} onChange={props.onChange}/>
            <div style={{height: 8}}/>
            <PrepMenu id="single-active" name="Door"
                      value={props.value}
                      editKey="singleActiveDoorPrep" editKeyCustom="singleActiveDoorPrepCustomTemplate"
                      editKeyCustomName="singleActiveDoorPrepCustomTemplateName"
                      groupKey="singleActiveDoorPreps" groupCustomKey="singleActiveDoorPrepsCustom"
                      group={group} onChange={props.onChange}/>

            <div style={{height: 18}}/>

            <Typography variant="body2">HW Preps (Pair)</Typography>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-frame" name="Frame"
                      value={props.value}
                      editKey="pairFramePrep" editKeyCustom="pairFramePrepCustomTemplate"
                      editKeyCustomName="pairFramePrepCustomTemplateName"
                      groupKey="pairFramePreps" groupCustomKey="pairFramePrepsCustom"
                      group={group} onChange={props.onChange}/>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-active-door" name="Active"
                      value={props.value}
                      editKey="pairActiveDoorPrep" editKeyCustom="pairActiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairActiveDoorPrepCustomTemplateName"
                      groupKey="pairActiveDoorPreps" groupCustomKey="pairActiveDoorPrepsCustom"
                      group={group} onChange={props.onChange}/>
            <div style={{height: 8}}/>
            <PrepMenu id="pair-inactive-door" name="Inactive"
                      value={props.value}
                      editKey="pairInactiveDoorPrep" editKeyCustom="pairInactiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairInactiveDoorPrepCustomTemplateName"
                      groupKey="pairInactiveDoorPreps" groupCustomKey="pairInactiveDoorPrepsCustom"
                      group={group} onChange={props.onChange}/>
            {(!!group.pairBothActiveDoorPreps || !!group.pairBothActiveDoorPrepsCustom) && <>
                <div style={{height: 8}}/>
                <PrepMenu id="pair-both-active-door" name="Both Active"
                      value={props.value}
                      editKey="pairBothActiveDoorPrep" editKeyCustom="pairBothActiveDoorPrepCustomTemplate"
                      editKeyCustomName="pairBothActiveDoorPrepCustomTemplateName"
                      groupKey="pairBothActiveDoorPreps" groupCustomKey="pairBothActiveDoorPrepsCustom"
                      group={group} onChange={props.onChange}/>
            </>}
        </>
    );
}